<script setup lang="ts">
  import { NavBar } from '@components/index'
  import navigate from '@utils/navigate'

  const listButtons = [
    { icon: 'house', title: 'Home', route: '/' },
    { icon: 'newspaper', title: 'Novidades', route: '/newsletter' },
    { icon: 'bookmark-plus', title: 'Favoritos', route: '/favorites' },
    { icon: 'door-closed', title: 'Sair', route: '/auth' }
  ]

  const handleClick = (route: string) => {
    if (route === '/auth') {
      clearTokens()
    }
    navigate.push(route)
  }
</script>

<template>
  <div class="main">
    <section>
      <div class="page container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10 col-xl-9">
            <NavBar
              :buttons="listButtons"
              :on-click="data => handleClick(data)"
            />
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container-fluid">
        <div class="row justify-content-center mx-1">
          <div class="col-12 col-md-10 col-xl-9">
            <slot role="main" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss">
  .main {
    background-image: url('/static/background-header-page.png');
    background-repeat: no-repeat;
    background-size: auto;
    background-position: center top;
    background-attachment: fixed;
    overflow-y: scroll;
    min-height: 100vh;
  }

  .page {
    position: relative;
  }

  .modal-open-stop-scroll {
    overflow: hidden;
  }
</style>
